import { css, Theme } from '@emotion/react'
import { chipClasses } from '@mui/material'

export const formGroup = css`
  display: flex;
  flex-direction: row;
  column-gap: 12px;
  row-gap: 8px;

  width: 100%;
`

export const chip = (active: boolean) => (theme: Theme) =>
  css`
    margin-left: 0;
    border-radius: 8px;
    border: 1px solid ${theme.colors.backgroundOne};
    padding: 5px 9px;

    background-color: ${active ? theme.colors.backgroundFive : 'transparent'};

    .${chipClasses.label} {
      display: flex;
      align-items: center;
      gap: 4px;

      padding: 0;

      color: ${theme.colors.typographyTwo};
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
    }

    :hover {
      box-shadow: none;

      background-color: ${theme.colors.backgroundThree};
    }
  `
